import React, { FC } from 'react';
import { Loading, Text } from '@moda/om';
import { useParams } from 'react-router-dom';
import { useDesigner } from '../../hooks/useDesigner';
import { Link } from '../Link';
import { hrefFor } from '../../routers';
import { DesignerEmailSubscribingButton } from './DesignerEmailSubscribingButton';

import './SubscribeEmailToDesignerModule.scss';

export const SubscribeEmailToDesignerModule: FC = () => {
  const { designerSlug } = useParams<{ designerSlug: string }>();
  const { designer, loading } = useDesigner(designerSlug);

  if (!designer) return null;

  if (loading) return <Loading />;

  return (
    <div className="SubscribeEmailToDesignerModule">
      <div className="SubscribeEmailToDesignerModule__info-panel">
        <Text treatment="h5">Receive Updates About This Designer</Text>

        <Text>
          To opt out,{' '}
          <Link
            className="SubscribeEmailToDesignerModule__opt-out-link"
            to={hrefFor.UnsubscribePage()}
          >
            unsubscribe here
          </Link>{' '}
          or in our emails.
        </Text>
      </div>

      <DesignerEmailSubscribingButton designer={designer} />
    </div>
  );
};
